import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PinTypesLogicService } from './logic/pin-types/pin-types-logic.service';
import { PinTypesService } from './logic/pin-types.service';
import { PinTypesDaoService } from './dao/pin-types-dao.service';
import { PinTypesDbDaoService } from './dao/pin-types-dao/pin-types-db-dao.service';
import { PinTypeDbTableDefinition } from './dao/pin-types-dao/pin-type-db-table-definition';
import { LocalPinTypeDbTableDefinition } from './dao/pin-types-dao/local-pin-type-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: PinTypesService, useClass: PinTypesLogicService },
    { provide: PinTypesDaoService, useClass: PinTypesDbDaoService },
    { provide: PinTypeDbTableDefinition },
    { provide: LocalPinTypeDbTableDefinition },
  ]
})
export class PinTypesModule {}
